import { Option } from '@storeblocks/radio';
import { StringBoolean, stringBooleanToBoolean } from 'Types/StringBoolean';
import { getAppText } from 'Utils/text';
import { isDefined } from 'Utils/type.utils';
import {
  BooleanOption,
  FieldValue,
  Props,
  StringBooleanOption,
} from './radioButton.types';

export function throwNotImplemented<T>(value: T): never {
  throw new Error(`Value (${value}) is not implemented`);
}

export const getOptions = ({ name, options, variant }: Props): Option[] => {
  switch (variant) {
    case 'boolean':
      return options?.map(booleanOptionToOption) ?? getYesAndNoOptions(name);
    case 'string':
    case undefined:
      return options;
    default:
      return throwNotImplemented(variant);
  }
};

export const booleanOptionToOption = (option: BooleanOption): Option => ({
  ...option,
  value: String(option.value),
});

export const stringOptionToBooleanOption = (
  option: StringBooleanOption,
): BooleanOption => ({
  ...option,
  value: stringBooleanToBoolean(option.value),
});

export function getValue(
  variant: Props['variant'],
  value: FieldValue,
): string | undefined {
  switch (variant) {
    case 'boolean':
      if (isDefined(value)) {
        return String(value as boolean);
      }
      return undefined;
    case 'string':
    case undefined:
      return value as string;
    default:
      return throwNotImplemented(variant);
  }
}

export const getYesAndNoOptions = (id: string): Option[] => [
  {
    id: `${id}-radio1`,
    label: getAppText('insurance_common.yes'),
    value: StringBoolean.TRUE,
  },
  {
    id: `${id}-radio2`,
    label: getAppText('insurance_common.no'),
    value: StringBoolean.FALSE,
  },
];
